type StorageLike = {
  getItem: (key: string) => string | null
  setItem: (key: string, value: string) => void
  removeItem: (key: string) => void
  clear: () => void
}

const createSafeStorage = (kind: 'sessionStorage' | 'localStorage'): StorageLike => {
  const access = (): Storage | null => {
    if (typeof window === 'undefined') return null
    try {
      return window[kind]
    } catch {
      return null
    }
  }
  return {
    getItem(key) {
      try {
        return access()?.getItem(key) ?? null
      } catch {
        return null
      }
    },
    setItem(key, value) {
      try {
        access()?.setItem(key, value)
      } catch {
        // ignore SecurityError / QuotaExceededError
      }
    },
    removeItem(key) {
      try {
        access()?.removeItem(key)
      } catch {
        // ignore
      }
    },
    clear() {
      try {
        access()?.clear()
      } catch {
        // ignore
      }
    },
  }
}

export const safeSessionStorage = createSafeStorage('sessionStorage')
export const safeLocalStorage = createSafeStorage('localStorage')
